import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import ArticlePage from '@/pages/article/page';
import ShoppingGuidePage from '@/pages/shopping-guide/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/article/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/shopping-guide',
    element: <ShoppingGuidePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;